// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contBox[data-v-78b65df0] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.contBox .phoneBox[data-v-78b65df0] {\n  width: 375px;\n  height: 500px;\n  border-radius: 10px;\n  border: 1px solid #e5e5e5;\n  margin: 0 20px;\n  overflow-y: auto;\n}", ""]);
// Exports
module.exports = exports;
